<!-- Migrated from legacy/Plus/Plus/index.shtml -->

<template>
  <p>
    VizbiPlus (Visualising the Future of Biomedicine) was a VIZBI project that ran from 2012 to
    2017. It aimed to improve how life science is communicated by training a new generation of
    science animators to create exemplary, scientifically accurate animations that inspire and
    educate the public about cutting-edge biomedical research. The project has since grown into
    the <router-link to="/collective">VIZBI Collective</router-link>.
  </p>
  <PortfolioHeading subtitle="Outcomes from VizbiPlus" />
  <VideoGallery collection="Plus" />
</template>

<script setup>
import VideoGallery from "@/components/VideoGallery.vue";
import PortfolioHeading from "@/components/PortfolioHeading.vue";
</script>
